import React, { type ReactElement } from 'react';
import { ColorValues, Flex, Typography } from '@banhala/ui-kit';
import { isNotNil } from 'shared/src/utils';
import { Tooltip } from 'shared/src/component/Tooltip';
import { IconTooltip } from './IconTooltip';

export const TitleContent: React.FC<{
  title: string;
  tooltip?: string;
  children: ReactElement | ReactElement[];
  onPress?: () => void;
}> = props => {
  return (
    <Flex.Row alignItems={'flex-start'} gap={4} justifyContent={'flex-start'}>
      <Flex.Row alignItems={'center'} width={68} height={24}>
        <Typography type={'subtitle2'} color={'content_tertiary'}>
          {props.title}
        </Typography>
        {isNotNil(props.tooltip) && (
          <Tooltip
            label={props.tooltip}
            contentStyle={{
              paddingHorizontal: 14,
              paddingVertical: 12,
              backgroundColor: ColorValues.slate60,
            }}
          >
            <IconTooltip />
          </Tooltip>
        )}
      </Flex.Row>
      <Flex
        flex={1}
        minHeight={24}
        alignSelf={'center'}
        alignItems={'flex-start'}
        justifyContent={'center'}
        onPress={props.onPress}
      >
        {props.children}
      </Flex>
    </Flex.Row>
  );
};
